import { useEffect, useMemo, useState } from 'react';

import { LOCAL_STORAGE_KEYS } from 'ts/constants/local-storage-keys';

import { outputDefaultLang, sourceDefaultLang } from '../components/modals/choseTranslateFormatModal/locales';
import type { Language } from '../components/modals/choseTranslateFormatModal/localesFull';
import { languages } from '../components/modals/choseTranslateFormatModal/localesFull';

export const useLanguageSelection = () => {
  const [sourceLang, setSourceLang] = useState<Language>(() => {
    const savedLang = localStorage.getItem(LOCAL_STORAGE_KEYS.DETECTED_LANG_FOR_TRANSLATE);

    if (savedLang) {
      const foundLang = sourceDefaultLang.find((lang) => lang.francName === savedLang);
      if (foundLang) return foundLang;

      const foundInAllLangs = languages.find((lang) => lang.francName === savedLang);
      if (foundInAllLangs) return foundInAllLangs;
    }

    return sourceDefaultLang[0];
  });

  const [outputLang, setOutputLang] = useState<Language>(() => {
    const savedLang = localStorage.getItem(LOCAL_STORAGE_KEYS.DETECTED_LANG_FOR_TRANSLATE);

    if (savedLang && savedLang !== 'eng' && savedLang !== 'und') {
      const englishLang = outputDefaultLang.find((lang) => lang.code === 'en');
      if (englishLang) return englishLang;

      const foundInAllLangs = languages.find((lang) => lang.code === 'en');
      if (foundInAllLangs) return foundInAllLangs;
    }

    return outputDefaultLang[0];
  });

  const sortedSourceDefaultLang = useMemo(() => {
    const savedLang = localStorage.getItem(LOCAL_STORAGE_KEYS.DETECTED_LANG_FOR_TRANSLATE);

    if (savedLang) {
      const foundLang = sourceDefaultLang.find((lang) => lang.francName === savedLang);
      if (foundLang) {
        const otherLangs = sourceDefaultLang.filter((lang) => lang.francName !== savedLang);
        return [foundLang, ...otherLangs];
      }
    }

    return sourceDefaultLang;
  }, []);

  const sortedOutputDefaultLang = useMemo(() => {
    const savedLang = localStorage.getItem(LOCAL_STORAGE_KEYS.DETECTED_LANG_FOR_TRANSLATE);

    if (savedLang && savedLang !== 'eng' && savedLang !== 'und') {
      const englishLang = outputDefaultLang.find((lang) => lang.code === 'en');
      if (englishLang) {
        const otherLangs = outputDefaultLang.filter((lang) => lang.code !== 'en');
        return [englishLang, ...otherLangs];
      }
    }

    return outputDefaultLang;
  }, []);

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.OUTPUT_LANG, outputLang.code);
    localStorage.setItem(LOCAL_STORAGE_KEYS.SOURCE_LANG, sourceLang.code);
  }, [outputLang, sourceLang]);

  return {
    sourceLang,
    setSourceLang,
    outputLang,
    setOutputLang,
    sortedSourceDefaultLang,
    sortedOutputDefaultLang
  };
};
